import { render, staticRenderFns } from "./ManageTable.vue?vue&type=template&id=4a9023ca&scoped=true&"
import script from "./ManageTable.vue?vue&type=script&lang=js&"
export * from "./ManageTable.vue?vue&type=script&lang=js&"
import style0 from "./ManageTable.vue?vue&type=style&index=0&id=4a9023ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9023ca",
  null
  
)

export default component.exports